module.exports = __webpack_public_path__ + "img/gasbot-smile.3c9e63ae.webp";